// These styles are injected into html, body
export default {};
